<template>
  <div class="wrapper">
    <div class="main-panel">
      <!-- <app-nav profileRouter="usr-profile"></app-nav> -->

      <Modal 
        :showModal="dialog"
        :ifTitle="true"
        :Title="'Seu check-in está próximo, deseja realizá-lo agora?'"
        :ifIcon="true"
        :Icon="'alarm_on'"
        :ifTwoBtn="true"
        :TextFirstBtn="'Não'"
        :TextSecondBtn="'Sim'"
        @btnUm="dialog = !dialog"
        @btnDois="'funcao'">
      </Modal>


      <router-view name="content" class="container" >
          
      </router-view>

      <!-- <app-footer></app-footer> -->

      <app-newMenu v-if="$route.path.includes('user')" ></app-newMenu>
    </div>
  </div>
</template>

<script>
import Footer from "../shared/UserFooter.vue";
import Navbar from "../shared/UserNavbar.vue";
import MenuModel from "../../models/Menu.js";
import NewMenu from "./NewMenu.vue"
import Modal from "../shared/ModalPadrao.vue"

export default {
  data: function() {
    return {
      homeUrl: "/user/minhas-reservas",
      profileRouter: "usr-profile",
      dialog: false
    };
  },
  computed: {
    menus() {
      return [
        new MenuModel(
          "Minhas Reservas",
          "history",
          "driver-vehicle-request-dashboard"
        ),
        new MenuModel(
          "Solicitar Reserva",
          "calendar_today",
          "driver-vehicle-request"
        ),
        new MenuModel(
          "Pagamento",
          "account_balance_wallet",
          "payment"
        )
      ];
    }
  },

  components: {
    "app-footer": Footer,
    "app-nav": Navbar,
    "app-newMenu": NewMenu,
    Modal
  }
};
</script>
<style lang="scss" scoped>

.container {
  @media (max-width: 768px) {
    max-width: 100%;
    min-width: 100%;
    width: 100% !important
  }
}
</style>


